import React from 'react'
import { Box, Image, Stack, Text, Flex, Button, Center } from '@chakra-ui/react'

import flyer_image from "../../src/img/test_flyer_image.png"

const Flyer = () => {
  return (
    <>
      <Flex flexDirection="column" justifyContent="center" alignItems="center" width="100%" height="auto" padding="3rem">
        <Stack bg="white" width="40%" height="auto" padding="1.4rem" spacing="1.5rem" borderRadius="4px" borderWidth="1px" borderColor="black">
          <Image src={flyer_image} alt="ELectric Commision Pic" />
          <Text fontWeight="700" fontSize="22px">Construction and maintenance of transmission lines</Text>
          <Text color="#616161" fontSize="14px">NAPTIN provides training on the following under-listed courses. The running of these courses are directly on your portal. Some of the courses are provided in specific centre(s) depending on where the facilities required for the training are available. Some of the courses are provided in specific centre(s) depending on where the facilities required for the training are available. Some of the courses are provided in specific centre(s) depending on where the facilities required for the training are available.</Text>
          <Flex flexDirection="row" justifyContent="space-between">
            <Stack>
              <Text color="#616161" fontSize="12px">Program type</Text>
              <Text fontWeight="600">Technical Course</Text>
            </Stack>
            <Stack>
              <Text color="#616161" fontSize="12px">Course code</Text>
              <Text fontWeight="600">CMD</Text>
            </Stack>
            <Stack>
              <Text color="#616161" fontSize="12px">RTC Centers</Text>
              <Text fontWeight="600">Lagos, Ikeja</Text>
            </Stack>
          </Flex>
          <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
              <Stack>
                <Text color="#616161" fontSize="12px">Cost</Text>
                <Text fontWeight="600">N950,000</Text>
              </Stack>
              <Button colorScheme="red" borderRadius="0px" fontSize="13px">
                Register for course
              </Button>
            </Flex>
        </Stack>
      </Flex>

    

    </>
  )
}

export default Flyer